import getSortbyFieldName from './get-sort-by-field-name';
const buildAzSort = (sortFilters, relations, stringProps) => {
  const sortValues = {};
  sortFilters.forEach(({
    sort,
    propsToDisplay
  }) => {
    if (!sort) return;
    const sortFieldName = getSortbyFieldName(relations, propsToDisplay, stringProps);
    if (sortFieldName) sortValues[sortFieldName] = sort.toLowerCase();
  });
  return sortValues;
};
const buildSortValues = (sortFilters, relations, stringProps, useSortObject) => {
  if (!sortFilters || !sortFilters.length) return useSortObject ? null : {
    sort: []
  };
  if (useSortObject) return buildAzSort(sortFilters, relations, stringProps);
  const sortValues = sortFilters.map(({
    sort,
    propsToDisplay,
    isScore
  }) => {
    if (isScore) return '_score';
    if (!sort) return null;
    const sortFieldName = getSortbyFieldName(relations, propsToDisplay, stringProps);
    return sortFieldName ? `${sortFieldName}:${sort.toLowerCase()}` : null;
  }).filter((item, index, arr) => !item ? false : arr.indexOf(item) === index).join(',');
  return {
    sort: sortValues
  };
};
export default buildSortValues;
//# sourceMappingURL=build-sort-values.js.map